import { defineStore } from 'pinia';
import { tItemsFromApi } from '@/Interfaces/caseComponentsLib';
import { iStoreItemsFromApi } from '@/Interfaces/iStoreItemsFromApi';

export const useStoreItemsFromApi = defineStore('useStoreItemsFromApi', {
    state: () :iStoreItemsFromApi => ({
        itemsFromApi: [],
    }),
    getters: {
        getApiItemByXmlId: (state) => {
            return (xmlId: string) => {
                return state.itemsFromApi?.find(item => item.xmlId === xmlId);
            };
        },
    },
    actions: {
        uploadApiCatalog(data: tItemsFromApi) {
            this.itemsFromApi = [ ...data ];
        },
    },
});
